// @core/api/endpoints/booking/mark_no_show.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  MarkNoShowRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Mark no-show
 * Marks a booking as NO_SHOW. Applies no-show penalty per policy, increments customer's no-show counter (triggers auto-ban if strike limit is reached).
 */
export async function MarkNoShow(
  target_type: string,
  target_id: string,
  data: MarkNoShowRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/no-show`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
